<template>
    <div :class="`[ c-form-item c-form-item--fluid ] u-flex-set ${ customClass ? customClass : ''}`">
        <label :for="name" class="u-hidden-visually">{{label}}</label>
        <v-select custom-class="u-fullwidth" :name="name" :id="name" :options="options">
            <slot></slot>
        </v-select>
    </div>
</template>

<script>
    import VSelect from '@/components/form/Select'

    export default {
        components: {
            VSelect
        },
        props: ['name', 'label', 'custom-class', 'options']
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";
</style>


// WEBPACK FOOTER //
// src/components/form/filters/FilterSelect.vue